import { WatcherFunction } from '..'
import { watchCheckRequest } from './check'

export const ipstackSagas: ReadonlyArray<WatcherFunction> = [watchCheckRequest]
